import { render, staticRenderFns } from "./BudgetInfo.vue?vue&type=template&id=39182a71"
import script from "./BudgetInfo.vue?vue&type=script&lang=js"
export * from "./BudgetInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports